/**
 * La charge de la fiche AFFICHÉE — recalculée à chaque ajustement.
 *
 * Le serveur la calcule à la composition ; mais retirer, ajouter ou remplacer
 * un exercice la change, et un résumé qui reste figé sur la composition
 * d'origine ment sur le document qu'on a sous les yeux. Constaté : après un
 * « +1 exercice », le résumé passait bien à « 4 exercices » et gardait
 * « au moins 10 questions » — les questions du quatrième n'étaient nulle part.
 *
 * Les règles sont les MÊMES que côté serveur (`backend/fiches/contrat.py`), et
 * c'est délibéré : un même document doit se décrire pareil des deux côtés. Un
 * test vérifie que les deux comptages concordent sur les mêmes énoncés.
 *
 * Ce qui n'est pas calculé ici, et ne le sera pas tant que ce n'est pas mesuré :
 * la durée. « Un exercice = cinq minutes » est une invention, pas une mesure.
 */

/** Les repères de question visibles : « a) » ou « a. » ouvrant une cellule. */
const REPERE_QUESTION = /(?:^|>)\s*([a-h])[.)](?=\s|<|$)/gi;

/** Le nombre de questions d'un exercice, ou null si rien ne permet de le dire. */
export function compterQuestions(exercice) {
  if (!exercice) return null;
  const verifiees = exercice.metadata?.questions_verifiees;
  if (Number.isInteger(verifiees) && verifiees >= 1 && verifiees <= 100) return verifiees;
  for (const porteur of [exercice, exercice.variables, exercice.metadata]) {
    const spec = porteur && porteur.spec;
    if (spec && Array.isArray(spec.questions)) {
      return spec.questions.length || null;
    }
  }
  const enonce = exercice.enonce_html || exercice.statement_html || "";
  if (!enonce) return null;
  const lettres = new Set();
  REPERE_QUESTION.lastIndex = 0;
  let trouve;
  while ((trouve = REPERE_QUESTION.exec(enonce)) !== null) {
    lettres.add(trouve[1].toLowerCase());
  }
  return lettres.size || null;
}

/** La charge du document tel qu'il est en ce moment. */
export function calculerCharge(exercices) {
  const liste = exercices || [];
  const comptes = liste.map(compterQuestions);
  const connus = comptes.filter((c) => c);
  return {
    exercices: liste.length,
    questions: connus.length ? connus.reduce((a, b) => a + b, 0) : null,
    // Vrai seulement si CHAQUE exercice sait se compter : sinon l'interface
    // doit dire « au moins ».
    exhaustif: liste.length > 0 && comptes.every((c) => c),
    duree_indicative_min: null,
  };
}

/** Le résumé lisible : « 3 exercices · au moins 10 questions ». */
export function resumerCharge(exercices) {
  const charge = calculerCharge(exercices);
  const morceaux = [
    `${charge.exercices} exercice${charge.exercices > 1 ? "s" : ""}`,
  ];
  if (charge.questions) {
    morceaux.push(
      `${charge.exhaustif ? "" : "au moins "}${charge.questions} question${charge.questions > 1 ? "s" : ""}`
    );
  }
  return morceaux.join(" · ");
}
